export default __webpack_public_path__ + "static/media/waterDayImageActive.b8114e7b.svg";